export default __webpack_public_path__ + "static/media/hotel_jp_2.a18966db.jpg";